<template>
  <div class="flex gap-2">
    <!-- eslint-disable-next-line vuejs-accessibility/anchor-has-content -->
    <a href="https://www.facebook.com/dfeswa" target="_blank">
      <facebook-icon aria-label="Facebook" />
    </a>
    <router-link to="/about#rss" target="_blank"><rss-icon aria-label="RSS information page" /></router-link>
  </div>
</template>

<script setup lang="ts">
import FacebookIcon from '@/common/assets/icons/facebook.svg';
import RssIcon from '@/common/assets/icons/rss.svg';
</script>
